import axios from 'axios'
import qs from 'qs'
import { Toast, Dialog } from 'vant'
import store from '@/store'
import { getToken } from '@/utils/auth'
import router from '@/router'
import i18n from '@/i18n/i18n'

// 创建一个axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // withCredentials: true,
  timeout: 60000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    console.log(config.baseURL)
    // config.baseURL = 'https://int.rr666.net'
    if (config.params && config.params.isRoute && config.baseURL.includes('https://')) {
      config.baseURL = process.env.VUE_APP_BASE_API2
    }
    if (localStorage.getItem('route') === '线路2' && config.baseURL.includes('https://')) {
      config.baseURL = process.env.VUE_APP_BASE_API2
      console.log(config.baseURL)
    } else if (localStorage.getItem('route') === '线路1' && config.baseURL.includes('https://')) {
      config.baseURL = process.env.VUE_APP_BASE_API
      console.log(config.baseURL)
    }
    if (localStorage.getItem('visitorId')) {
      config.headers.visitorId = localStorage.getItem('visitorId')
    }
    config.headers.lang = localStorage.lang || 'cn'
    const load = document.getElementById('load_all')
    const loadPortal = document.getElementById('load_portal')
    const homePortal = document.getElementById('home_portal')
    if (loadPortal && loadPortal.style.display === 'none' && window.location.href.includes('home') && config.url.includes('/gethomedata')) {
      loadPortal.style.display = 'block'
      homePortal.style.display = 'none'
    }
    if (load && load.style.display === 'none' && (config.url.includes('task/lingAct') || config.url.includes('/save') || config.url.includes('/getGameplayList') || config.url.includes('/getGameLsitbyown') || config.url.includes('/getGameplayHotList') || config.url.includes('/getGameplayLastList'))) {
      load.style.display = 'flex'
    }
    if (config.url.includes('/getgamechiprate')) {
      load.style.display = 'flex'
    }
    if (store.getters.token || getToken()) {
      config.headers.Authorization = getToken()
      config.headers.suidvisitorid = getToken() || store.getters.token + localStorage.getItem('visitorId')
      if (config.params) {
        config.params.suid = getToken() || store.getters.getToken
      } else {
        config.params = {}
        config.params.suid = getToken() || store.getters.token
      }
      if (config.url.includes('/getLogo')) {
        config.params = {}
      }
    }
    return config
  },
  error => {
    console.log(error)
    Toast.fail('请求失败，请检查网络或联系客服' + error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const load = document.getElementById('load_all')
    if (load && load.style.display === 'flex') {
      load.style.display = 'none'
    } else {
      // load.style.display = 'none'
    }
    const loadPortal = document.getElementById('load_portal')
    const homePortal = document.getElementById('home_portal')
    if (loadPortal && loadPortal.style.display === 'block') {
      loadPortal.style.display = 'none'
      homePortal.style.display = 'block'
    } else {
      // load.style.display = 'none'
    }
    const res = response.data
    // res.status = '8888'
    // 返回码不正确
    if (res.status != '1') {
      if (res.code === 401) {
        Dialog.alert({
          title: i18n.t('bottomTab.zmk10'),
          message: i18n.t('bottomTab.zmk11')
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            router.push({ name: 'Login' })
          })
        })
      }
      // 订单轮询
      if (res.code === 5002) {
        return Promise.reject(new Error(res.msg || 'Error'))
      }
      // Toast.fail(res.msg)
      if (res.status == '8888') {
        // const suid = getToken() || store.getters.token
        if (router.path !== '/upgradeSystem') {
          router.push({ path: '/upgradeSystem' })
        }
        return res
      } else if (res.msg && res.msg.includes(i18n.t('bottomTab.zmk09'))) {
        Toast({
          message: i18n.t('bottomTab.zmk05'),
          icon: 'warning-o'
        })
        store.dispatch('user/resetToken')
        return Promise.reject(new Error(res.msg || 'Error'))
      } else if (!res.msg) {
        Toast({
          message: '接口返回结构不正确，请联系客服',
          // message,
          icon: 'warning-o'
        })
      } else {
        const message = i18n.t('cwm.' + res.lcode)
        if (message.includes('XXXXXX')) {
          message.replace('XXXXXX', res.lcodevalue)
        }
        Toast({
          message: res.msg,
          // message,
          icon: 'warning-o'
        })
        return Promise.reject(new Error(res.msg || 'Error'))
      }
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error)
    Toast.fail(error.message)
    if (error.message === 'Network Error') {
      if (router.history && router.history.current && router.history.current.path !== '/changeApiRoute') {
        router.push({ path: '/changeApiRoute' })
      } else {
        router.push({ path: '/changeApiRoute1' })
      }
    }
    return Promise.reject(error)
  }
)

/**
 * 使用 application/x-www-form-urlencoded format
 * @param {*} url
 * @param {*} postData
 * @returns
 */
service.formDataPost = function(url, postData) {
  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data: qs.stringify(postData),
    url
  }
  return service(options)
}

export default service
